// extracted by mini-css-extract-plugin
export default {"tagLabel":"TagsCellRenderer_tagLabel__5kIFa"};